import React from 'react';
import Modal from 'react-bootstrap/Modal';

//First mobile card needs to be updated for departure vs arrival

//"Subscribe" to "Notify Me"
export default class DetailModal extends React.Component {
    render() {

        if (this.props.model === undefined) {
            return (
               null
            )
        }

        return(<Modal show={this.props.isShowing} size={"lg"} centered onHide={this.props.close}>
            <Modal.Header>

                <Modal.Title className="w-100 text-center">
                    <img className="img-fluid text-center" style={{position: 'absolute',
                        top: 0,
                        right: 0,
                        left: 0,
                        margin: 'auto'}}
                         src={this.props.model.LogoLarge}
                         alt={this.props.model.Airline}/>

                </Modal.Title>
                <button type="button" style={{}}
                        onClick={this.props.close} className="close">
                    <span aria-hidden="true">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid">
                    <div className="row text-center">
                        <div className="col-12">
                            <h4>{'Flight# '+this.props.model.Flightnumber}</h4>
                        </div>
                        <div className="col-md-6 col-12 my-md-5">
                            <div className="col-12" style={{background: 'rgb(215, 225, 238)'}}>
                                {this.props.model.AD === 'D' ? 'Destination' : 'Originating City'}
                            </div>
                            <div className="col-12">
                                {this.props.model.Destination}
                            </div>
                        </div>
                        <div className="col-md-6 col-12 my-md-5">
                            <div className="col-12" style={{background: 'rgb(215, 225, 238)'}}>Gate</div>
                            <div
                                className="col-12">{this.props.model.Gate === '' ? 'TBD' : this.props.model.Gate}</div>
                        </div>

                        <div className="col-md-3 col-12 my-md-5 ">
                            <div className="col-12 " style={{background: 'rgb(215, 225, 238)'}}>Scheduled</div>
                            <div className="col-12">{this.props.model.ScheduledDateTime}</div>
                        </div>
                        <div className="col-md-3 col-12 my-md-5 ">
                            <div className="col-12 " style={{background: 'rgb(215, 225, 238)'}}>Estimated</div>
                            <div className="col-12">{this.props.model.Estimated === '' ? this.props.model.ScheduledDateTime : this.props.model.Estimated}</div>
                        </div>
                        <div className="col-md-3 col-12 my-md-5 ">
                            <div className="col-12 " style={{background: 'rgb(215, 225, 238)'}}>Actual</div>
                            <div className="col-12">{this.props.model.Actual}</div>
                        </div>
                        <div className="col-md-3 col-12 my-md-5 ">
                            <div className="col-12 " style={{background: 'rgb(215, 225, 238)'}}>Chock Time</div>
                            <div
                                className="col-12">{this.props.model.ChockTime === '' ? 'TBD' : this.props.model.ChockTime}</div>
                        </div>

                    </div>
                </div>
            </Modal.Body>
            {this.props.notifications && this.props.model.Status !== 'Arrived' && this.props.model.Status !== 'Departed' ? <Modal.Footer>
                <button disabled={this.props.model.Status === 'Arrived'}
                    onClick={() => this.props.navigationFunc(true)}
                    className="btn btn-primary  btn-block">Notify Me</button>
            </Modal.Footer> : null}
        </Modal>);

    }
}